import { render, staticRenderFns } from "./WidgetStatistic.vue?vue&type=template&id=4a700797&"
import script from "./WidgetStatistic.vue?vue&type=script&lang=js&"
export * from "./WidgetStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports